import React from "react"
import NewsComponent from "./News"
import newsFactory from "./news.factory"

export { default as NewsQuery } from "./news.query"

export const News = props => {
  const { data } = props
  const componentProps = { ...props, ...newsFactory.transform(data) }
  return <NewsComponent {...componentProps} />
}
